<template>
  <div class="container"><files-list></files-list></div>
</template>
<script>
import FilesList from './FilesList.vue'
export default {
  components: { FilesList },
  data() {
    return {}
  },
}
</script>
